import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import FUNNEL_CONSTANTS from "../constants";

export const AveragesFilter = () => {
  const dispatch = useDispatch();

  const selected = useSelector((state) => state.laser.selectedFilters.average);

  return (
    <MultiSelectDropdown
      options={FUNNEL_CONSTANTS.AVERAGE_OPTIONS}
      selectedFilters={selected}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.setAverage(data))}
    />
  );
};
